import React, { useEffect, useState } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { RecordsKeeperAIBreadCrumbs } from '../core/_constants'
import { useIntl } from 'react-intl'
import { Card } from 'react-bootstrap'
import FileUsage from '../components/Overview/FileUsage'
import AvailableStorage from '../components/Overview/AvailableStorage'
// import ReferEarn from '../../../../media/images/refer-earn.png'
import RecentlyVisitedFiles from '../components/Overview/RecentlyVisitedFiles'
import MostVisitedFolders from '../components/Overview/MostVisitedFolders'
import QuickViewRecentUploads from '../components/Overview/QuickViewRecentUploads'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import RecordsKeeperAIGenerator from '../components/RecordsKeeperAIGenerator'
import '../styles/overview.scss'
import { useUpdateSettingsData } from '../../../hooks/updateSettingsData'
import { useAuth } from '../../auth'
import { getOverviewDataActivityApi, getOverviewDataApi } from '../core/_requests'
import {
  DataActivityTypes,
  MostVisitedFoldersTypes,
  RecentlyVisitedFilesTypes,
  RecordKeeperDashboardFileTypes,
} from '../core/_models'
import { OverviewDataActivity } from '../components/Overview/OverviewDataActivity'
import { toast } from 'react-toastify'
import { allowedFileTypes } from '../../../core/_constants'
import { FileUpload } from '../../widgets/components/FileUpload'

const Overview: React.FC = () => {
  const { formatMessage } = useIntl()
  const { updateSettings } = useUpdateSettingsData()
  const { companyId } = useAuth()
  const [modalStatus, setModalStatus] = useState(false)
  const [overviewDataActivityData, setOverviewDataActivityData] = useState<DataActivityTypes>({
    uploadedFileSizes: [],
    downloadedFileSizes: [],
  })
  const [overviewData, setOverviewData] = useState<{
    recentVisitedFiles: RecentlyVisitedFilesTypes
    mostVisitedFolders: MostVisitedFoldersTypes
    fileCounts: RecordKeeperDashboardFileTypes
    recordKeeperFileCount: number
    recordKeeperFiles: any
    recordKeeperFilesForTimeAgo: any
  }>({
    recentVisitedFiles: [],
    mostVisitedFolders: [],
    fileCounts: { audio: 0, documents: 0, images: 0, others: 0, videos: 0 },
    recordKeeperFileCount: 0,
    recordKeeperFiles: [],
    recordKeeperFilesForTimeAgo: [],
  })

  const [dataActivityLoading, setDataActivityLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    updateSettings()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const [selectedDataActivity, setSelectedDataActivity] = useState('thisWeek')

  const fetchOverviewData = async () => {
    if (!companyId) return
    setLoading(true)
    try {
      const {
        data: { success, data },
      } = await getOverviewDataApi(companyId)
      if (success) {
        setOverviewData(data)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const fetchDataActivity = async () => {
    if (!companyId) return
    setDataActivityLoading(true)
    try {
      const {
        data: { success, data },
      } = await getOverviewDataActivityApi(companyId, selectedDataActivity)
      if (success) {
        setOverviewDataActivityData(data)
      }
    } catch (error) {
      console.error(error)
    } finally {
      setDataActivityLoading(false)
    }
  }

  useEffect(() => {
    fetchOverviewData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchDataActivity()
  }, [selectedDataActivity]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PageTitle
        breadcrumbs={RecordsKeeperAIBreadCrumbs}
        description={formatMessage({ id: 'Overview' })}
      >
        {formatMessage({ id: 'RecordsKeeper AI' })}
      </PageTitle>
      {/* button for Desktop view */}
      <div
        // className={`d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block ${planStatus === 'payment_due' && 'planstatus-adjustment'} ${planStatus === 'paid' && 'planstatus-not-adjustment'}`}
        className='d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block'
        style={{ top: '80px', right: '30px' }}
      >
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              className='btn bg-primary custom-button-property font-size-13 text-white font-weight-400 w-100 d-flex align-items-center justify-content-center height-36'
              onClick={() => setModalStatus(true)}
            >
              {formatMessage({ id: 'Add new files' })}
            </button>
          </div>
        </div>
      </div>
      {/* button for mobile view */}
      <div className='d-flex align-items-center gap-2 gap-lg-3 d-block d-sm-none px-6'>
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-md-flex justify-content-md-end w-100 w-md-auto'>
            <button
              type='button'
              className='btn bg-primary custom-button-property font-size-13 text-white mb-4 font-weight-400 w-100 d-flex align-items-center justify-content-center height-36'
              onClick={() => setModalStatus(true)}
            >
              {formatMessage({ id: 'Add new files' })}
            </button>
          </div>
        </div>
      </div>
      <div className='px-6'>
        <div>
          <InfoCard2
            title={'Getting Started with RecordsKeeper Overview'}
            desc={
              'This page provides a snapshot of your key files, actions, and folders to help you quickly navigate and manage your records. Click on any item for more details or explore the Analytics and Reports sections for deeper insights.'
            }
            slug={'#'}
          />
          <RecordsKeeperAIGenerator />
        </div>

        <div className='d-md-flex gap-4 my-4'>
          <div className='d-flex flex-md-row flex-column gap-4 w-100'>
            <Card className='data-activity-card bg-white'>
              <OverviewDataActivity
                dataActivity={overviewDataActivityData}
                isLoading={dataActivityLoading}
                selectedDataActivity={selectedDataActivity}
                setSelectedDataActivity={setSelectedDataActivity}
              />
            </Card>
            <Card className='file-usage-card bg-white'>
              <FileUsage overviewData={overviewData} loading={loading} />
            </Card>
            {/* <div className=' d-flex flex-column gap-4 justify-content-start w-100' style={{ width: '15%' }}> */}
            <Card className='justify-content-center bg-white storage-available-card'>
              <AvailableStorage />
            </Card>
          </div>
        </div>
        <RecentlyVisitedFiles
          isLoading={loading}
          recentlyVisitedFiles={overviewData.recentVisitedFiles}
        />
        <MostVisitedFolders
          isLoading={loading}
          mostVisitedFolders={overviewData.mostVisitedFolders}
        />
        <QuickViewRecentUploads overviewData={overviewData} loading={loading} />
      </div>
      <FileUpload
        fileSize={parseInt(process.env.REACT_APP_RK_MAX_ZIP_FILE_SIZE as string)}
        maxFileNumber={10}
        allowType={allowedFileTypes}
        metaData={{ module: 'document', isProtected: false }}
        modalStatus={modalStatus}
        handleClose={() => {
          setModalStatus(false)
        }}
        handleSuccess={(id: number, name: string) => {
          toast.success(
            `${name
              .split('/')
              .pop()} uploaded successfully! Please wait for 1-2 minutes while the file is processed with AI. After that you can check the "Records & Files" section or "Overview" section`
          )
          fetchOverviewData()
          fetchDataActivity()
        }}
        resourceType='all'
        assemblyOption='rk-doc-upload'
      />
    </>
  )
}

export default Overview
